export default [
    { id: "kubernetes", name: "Kubernetes" },
    { id: "database", name: "Database" },
    { id: "storage", name: "Storage" },
    { id: "virtual-machine", name: "VirtualMachine" },
    { id: "lambda", name: "Lambda" },
    { id: "vpc", name: "Vpc" },
    { id: "other", name: "Other" }
];